import React from 'react';
import PropTypes from 'prop-types';
var PrimitiveContext = /*#__PURE__*/React.createContext({});
export default PrimitiveContext;
/**
 * Defines a context to supply the environment-specific Primitive component.
 */

var PrimitiveProvider = function PrimitiveProvider(_ref) {
  var Primitive = _ref.Primitive,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(PrimitiveContext.Provider, {
    value: Primitive
  }, children);
};

PrimitiveProvider.propTypes = {
  Primitive: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired
};
export { PrimitiveProvider };